export default {
  API: ["DELETE", "SAVE"],
  DB: ["DELETE", "TEST", "SAVE"],
  SAAS: ["DELETE", "SAVE_AND_AUTHORIZE"],
  REMOTE: ["DELETE", "SAVE"],
};
